<template>
  <div class="content-wrapper">
    <app-tab :tabs="tabs" :icon="pageIcon" :isShowHeader=false></app-tab>
  </div>
</template>

<script>

import {Search} from "@Views/Screening/utility/apiAgent";

export default {

  name: "Search",
  props: {
    candidate: {
      type: Object
    },
    address: {
      type: Array,
    },
    applicantSearch : {
      type : Object
    },
    onAddCheck: Function,
  },
  data() {
    return {
      pageTitle: 'Search',
      pageIcon: 'search',
      tabs: [
        {
          "name": this.$t('sia_license_check'),
          "title": this.$t('sia_license_check'),
          "component": "sia-license-check",
          "permission": "",
          props: {
            candidate: this.candidate,
            address: this.address,
            applicantSearch: this.applicantSearch,
          }
        },
        {
          "name": this.$t('financial_sanctions'),
          "title": this.$t('financial_sanctions'),
          "component": "financial-sanctions",
          "permission": "",
          props: {
            candidate: this.candidate,
            address: this.address,
            applicantSearch: this.applicantSearch
          }
        },
        {
          "name": this.$t('right_to_work'),
          "title": this.$t('right_to_work'),
          "component": "right-to-work",
          "permission": "",
          props: {
            candidate: this.candidate,
            address: this.address,
            applicantSearch: this.applicantSearch
          }
        },
        {
          "name": this.$t('credit_check'),
          "title": this.$t('credit_check'),
          "component": "credit-check",
          "permission": "",
          props: {
            candidate: this.candidate,
            address: this.address,
            applicantSearch: this.applicantSearch
          }
        },
        {
          "name": this.$t('social_media_check'),
          "title": this.$t('social_media_check'),
          "component": "social-media-check",
          "permission": "",
          props: {
            candidate: this.candidate,
            address: this.address,
            applicantSearch: this.applicantSearch,
            onAddCheck:this.onAddCheck,
          }
        }
      ],
    }
  }
}
</script>

<style scoped>

</style>